export const ERROR_MESSAGES = {
    GENERIC_ERROR: 'Something went wrong. Please try again later.',
    METAMASK_NOT_INSTALLED: 'Please install Metamask.',
    WRONG_CHAIN: 'Please change network to $i.',
    NOT_OWNER: "You don't have any Elder Ent."
};
